import { ConfigProvider } from "vant";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ConfigProvider);
});
